import React, {useRef, useState, useEffect} from "react";
import {Tab, Tabs} from "react-bootstrap";
import {getParagraph} from "../../../utils/paragraphHelpers";

const TabView = ({tabs, value, setValue}) => {
  const tabContentRef = useRef(null);
  const [minHeight, setMinHeight] = useState(null);

  useEffect(() => {
    setMinHeight(tabContentRef?.current ? tabContentRef?.current?.clientHeight : null)
  }, [])

  return (
    <div ref={tabContentRef} className="grid-tabs grid-tabs-margin" style={minHeight ? {minHeight: `${minHeight}px`} : null}>
      <Tabs defaultActiveKey={value} onSelect={setValue}>
        {tabs?.map((item, key) => {
          return (
            <Tab key={key} eventKey={key} title={item?.field_tab_title}>
              {item?.relationships?.field_tab_content?.map((node) => getParagraph(node, {tabData: {current: key, selected: value}}))}
            </Tab>
          );
        })}
      </Tabs>
    </div>
  )
}

export default TabView;